import { pushRoute } from '../../../../lib/router.js';
import { isBase64Image } from '../../../../lib/utils.js';

const changeUploadParticipantMessage =
  'Are you sure you want to switch to another input method? Not saved participants will be lost.';

export const stepStakeholderNewUrl =
  'projects/stakeholders/new/step-stakeholder';
export const stepStakeholderEditUrl =
  'projects/stakeholders/edit/step-stakeholder';
export const stepInformationNewUrl =
  'projects/stakeholders/new/step-information';
export const stepInformationEditUrl =
  'projects/stakeholders/edit/step-information';
export const stepGroupParticipantsNewUrl =
  'projects/stakeholders/new/step-group-participants';
export const stepGroupParticipantsEditUrl =
  'projects/stakeholders/edit/step-group-participants';
export const stepCommunicatorsNewUrl =
  'projects/stakeholders/new/step-communicators';
export const stepCommunicatorsEditUrl =
  'projects/stakeholders/edit/step-communicators';
export const stakeholdersUrl = 'projects/stakeholders';
export const stakeholderUrl = 'projects/stakeholders/show';

export const navigateToStepStakeholder = (editing, projectId, stakeholderId) =>
  editing
    ? pushRoute(stepStakeholderEditUrl, { projectId, stakeholderId })
    : pushRoute(stepStakeholderNewUrl, { projectId });

export const navigateToStepInformation = (editing, projectId, stakeholderId) =>
  editing
    ? pushRoute(stepInformationEditUrl, { projectId, stakeholderId })
    : pushRoute(stepInformationNewUrl, { projectId });

export const navigateToStepGroupParticipants = (
  editing,
  projectId,
  stakeholderId
) =>
  editing
    ? pushRoute(stepGroupParticipantsEditUrl, { projectId, stakeholderId })
    : pushRoute(stepGroupParticipantsNewUrl, { projectId });

export const navigateToStepCommunicators = (
  editing,
  projectId,
  stakeholderId
) =>
  editing
    ? pushRoute(stepCommunicatorsEditUrl, { projectId, stakeholderId })
    : pushRoute(stepCommunicatorsNewUrl, { projectId });

export const onReset = (editing, projectId, stakeholderId) => {
  navigateToStepStakeholder(editing, projectId, stakeholderId);
};

export const stakeholdersParentTypeOptions = [
  { label: 'Select from existing Stakeholders Structure', value: 'existing' },
  { label: 'Independent Stakeholder', value: 'independent' },
];

export const onCreateUpdateCancel = (draftId, action, projectId) => {
  if (draftId) {
    action(draftId).then(() => pushRoute(stakeholdersUrl, { projectId }));
  } else {
    pushRoute(stakeholdersUrl, { projectId });
  }
};

export const generalStepValidate = (
  selectedOrgStakeholderId,
  stakeholderParentType,
  selectedImage,
  imageSize,
  values
) => {
  const errors = {};

  if (stakeholderParentType === 'existing' && !selectedOrgStakeholderId) {
    errors.name = 'Name is required';
  }

  if (stakeholderParentType === 'independent' && !values.name) {
    errors.name = 'Name is required';
  }

  if (selectedImage && imageSize) {
    if (!isBase64Image(selectedImage)) {
      errors.avatar = 'Allowed formats: .jpeg, .png, .jpg';
    }
  }

  if (selectedImage && imageSize > 10485760) {
    errors.avatar = 'Max file size: 10Mb';
  }

  return errors;
};

export const onParticipantsUploadChange = (method, setUploadMethod) => {
  if (window.confirm(changeUploadParticipantMessage)) {
    setUploadMethod(method);
  }
};
